export const STEP_SELECT_COPY_TO_TOUR_OPTIONS = 'select_copy_to_tour_options';
export const STEP_SELECT_COPIED_DATES = 'select_copied_dates';
export const STEP_CONFIRM_COPIED_DATES = 'confirm_copied_dates';
